module.exports = __webpack_public_path__ + "e0106718/img/scraper-icon.df6ccde5.svg";